
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined shape 1280","d":"M8 16a8 8 0 118-8 8.009 8.009 0 01-8 8zM4.8 7.2a.8.8 0 100 1.6h6.4a.8.8 0 100-1.6z","fill":"#607d8b"}})])
          )
        }
      }
    